class AudioService {
  private sounds: Map<string, HTMLAudioElement> = new Map()
  private enabled: boolean = true
  private volume: number = 0.5

  preload(name: string, path: string): void {
    const audio = new Audio(path)
    audio.preload = 'auto'
    audio.volume = this.volume
    this.sounds.set(name, audio)
  }

  play(name: string): void {
    if (!this.enabled) return
    const audio = this.sounds.get(name)
    if (!audio) return
    // Reset to start so rapid-fire plays work
    audio.currentTime = 0
    audio.play().catch(() => {
      // Silently ignore — file may not exist or autoplay may be blocked
    })
  }

  setEnabled(enabled: boolean): void {
    this.enabled = enabled
  }

  setVolume(volume: number): void {
    this.volume = Math.max(0, Math.min(1, volume))
    this.sounds.forEach(audio => {
      audio.volume = this.volume
    })
  }
}

export const audioService = new AudioService()
